module.exports = __webpack_public_path__ + "static/media/cloudimg.9f0bee45.png";